import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { Col, FormControl, FormGroup, Row } from 'react-bootstrap';
import translate from '../../translate';
import ValidatorFormGroup from '../../main/validator-form-group';
import _ from 'lodash';

export const MULTI_FAMILY_HOUSE = 'multi_family_house';

const VALIDATORS = {
    num_of_machines: {
        isValid: (value) =>
            /^[0-9]{0,4}$/.test(`${value}`) && `${value}`.length < 5,
    },
    housing_units: {
        isValid: (value) =>
            /^[0-9]{0,4}$/.test(`${value}`) && `${value}`.length < 5,
    },
};

const ObjectInfoForm = createReactClass({
    displayName: 'ObjectInfoForm',

    propTypes: {
        info: PropTypes.shape({
            mansion_type: PropTypes.string,
            num_of_machines: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
            housing_units: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
        }),
        handleChange: PropTypes.func.isRequired,
        forceValidation: PropTypes.bool,
        disabled: PropTypes.bool,
        strings: PropTypes.object,
    },

    defaultProps: {
        info: {},
        disabled: false,
        forceValidation: false,
        strings: {
            mansion_type: 'Objekttyp',
            num_of_machines: 'Anzahl Maschinen',
            housing_units: 'Wohneinheiten',
        },
    },

    getInitialState() {
        return _.extend(
            { _valid: true },
            {
                mansion_type: MULTI_FAMILY_HOUSE,
                num_of_machines: '',
                housing_units: '',
                _dirty: {},
                _valid: false,
            },
            this.props.info
        );
    },

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
            this.setState(nextProps.info, this._persistState);
        }
    },

    _persistState() {
        const new_state = {};
        _.each(
            ['mansion_type', 'num_of_machines', 'housing_units'],
            (fieldName) => {
                new_state[fieldName] = this.state[fieldName];
            }
        );
        // return valid state to parent
        new_state._valid = Object.keys(VALIDATORS).reduce(
            (formValid, fieldName) =>
                formValid &&
                VALIDATORS[fieldName].isValid(new_state[fieldName]),
            true
        );
        this.props.handleChange(new_state);
    },

    _markDirty(key) {
        const newDirt = {};
        newDirt[key] = true;
        const newState = _.extend({}, this.state, {
            _dirty: _.extend({}, this.state._dirty, newDirt),
        });
        this.setState(newState);
    },

    _handleFieldChange(key, value) {
        this._markDirty(key);
        const newSt = _.set({}, key, value);
        newSt[key] = value;
        this.setState(newSt, this._persistState);
    },

    render() {
        return (
            <div>
                <FormGroup>
                    <label htmlFor="">{this.props.strings.mansion_type}</label>
                    <div className="form-line">
                        <select
                            className="form-control"
                            name="mansion_type"
                            onChange={(event) => {
                                this._handleFieldChange(
                                    'mansion_type',
                                    event.target.value
                                );
                            }}
                            value={this.state.mansion_type}
                            disabled={this.props.disabled}
                            required
                            data-testid="mansion-type-select"
                        >
                            <option value={MULTI_FAMILY_HOUSE}>
                                {this.props.strings.optionMultiFamilyHouse}
                            </option>
                            <option value="student_housing">
                                {this.props.strings.optionStudentHousing}
                            </option>
                            <option value="campsite">
                                {this.props.strings.optionCampsite}
                            </option>
                            <option value="clinic">
                                {this.props.strings.optionClinic}
                            </option>
                            <option value="serviced_apartment">
                                {this.props.strings.optionServicedApartment}
                            </option>
                            <option value="micro_living">
                                {this.props.strings.optionMicroLiving}
                            </option>
                            <option value="senior_living">
                                {this.props.strings.optionSeniorLiving}
                            </option>
                            <option value="other_or_not_known">
                                {this.props.strings.optionOtherNotKnown}
                            </option>
                            <option value="hotel">
                                {this.props.strings.optionHotel}
                            </option>
                            <option value="hostel">
                                {this.props.strings.optionHostel}
                            </option>
                            <option value="staff_housing">
                                {this.props.strings.optionStaffHousing}
                            </option>
                            <option value="truck_stop">
                                {this.props.strings.optionTruckStop}
                            </option>
                            <option value="vacation_apartment_or_home">
                                {this.props.strings.optionVacationApartment}
                            </option>
                            <option value="fitters_flat">
                                {this.props.strings.optionFittersFlat}
                            </option>
                            <option value="public_laundrette">
                                {this.props.strings.optionPublicLaundrette}
                            </option>
                        </select>
                    </div>
                </FormGroup>
                <Row>
                    <Col xs={6} sm={6} md={6} lg={6}>
                        <ValidatorFormGroup
                            label={this.props.strings.num_of_machines}
                            hideErrorLabel={
                                !(
                                    this.state._dirty.num_of_machines ||
                                    this.props.forceValidation
                                ) ||
                                VALIDATORS.num_of_machines.isValid(
                                    this.state.num_of_machines
                                )
                            }
                            errorLabel={this.props.strings.num_of_machinesError}
                        >
                            <FormControl
                                type="text"
                                className="input-text-color"
                                value={this.state.num_of_machines}
                                name="num_of_machines"
                                onChange={(event) => {
                                    this._handleFieldChange(
                                        'num_of_machines',
                                        event.target.value
                                    );
                                }}
                                required
                                disabled={this.props.disabled}
                            />
                        </ValidatorFormGroup>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                        <ValidatorFormGroup
                            label={this.props.strings.housing_units}
                            hideErrorLabel={
                                !(
                                    this.state._dirty.housing_units ||
                                    this.props.forceValidation
                                ) ||
                                VALIDATORS.housing_units.isValid(
                                    this.state.housing_units
                                )
                            }
                            errorLabel={this.props.strings.housing_unitsError}
                        >
                            <FormControl
                                type="text"
                                className="input-text-color"
                                value={this.state.housing_units}
                                name="housing_units"
                                onChange={(event) => {
                                    this._handleFieldChange(
                                        'housing_units',
                                        event.target.value
                                    );
                                }}
                                required
                                disabled={this.props.disabled}
                            />
                        </ValidatorFormGroup>
                    </Col>
                </Row>
            </div>
        );
    },
});

export default translate('ObjectInfoForm')(ObjectInfoForm);
